const renderDeliveryDate = (element) => {
  if (!element || element.dataset.rendered === 'true') return;

  const minBusinessDays = Math.max(
    1,
    Number.parseInt(element.dataset.minBusinessDays || '5', 10)
  );
  const maxBusinessDays = Math.max(
    minBusinessDays,
    Number.parseInt(element.dataset.maxBusinessDays || '7', 10)
  );
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);

  const addBusinessDays = (startDate, numberOfDays) => {
    const date = new Date(startDate);
    let remainingDays = numberOfDays;

    while (remainingDays > 0) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();

      if (weekday !== 0 && weekday !== 6) {
        remainingDays -= 1;
      }
    }

    return date;
  };

  const firstDate = addBusinessDays(today, minBusinessDays);
  const lastDate = addBusinessDays(today, maxBusinessDays);
  const locale =
    element.dataset.locale ||
    document.documentElement.lang ||
    'lt-LT';

  const getDateParts = (date) => {
    const parts = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long'
    }).formatToParts(date);

    return {
      day: parts.find((part) => part.type === 'day')?.value || '',
      month: parts.find((part) => part.type === 'month')?.value || ''
    };
  };

  const formatDeliveryRange = (startDate, endDate) => {
    const start = getDateParts(startDate);
    const end = getDateParts(endDate);
    const sameYear = startDate.getFullYear() === endDate.getFullYear();
    const sameMonth =
      sameYear && startDate.getMonth() === endDate.getMonth();

    if (sameMonth) {
      return `${start.month} ${start.day}–${end.day} d.`;
    }

    if (sameYear) {
      return `${start.month} ${start.day} d. – ${end.month} ${end.day} d.`;
    }

    const fullDateFormatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });

    return (
      fullDateFormatter.format(startDate) +
      ' – ' +
      fullDateFormatter.format(endDate)
    );
  };

  const output = element.querySelector('[data-delivery-date]');

  if (output) {
    output.textContent = formatDeliveryRange(firstDate, lastDate);
    output.style.whiteSpace = 'nowrap';
    element.hidden = false;
  }

  element.dataset.rendered = 'true';
};

const watchDeliveryDate = (element) => {
  if (element.deliveryDateObserver) return;

  element.deliveryDateObserver = new MutationObserver(() => {
    const output = element.querySelector('[data-delivery-date]');

    if (!output?.textContent.trim() || element.hidden) {
      element.dataset.rendered = 'false';
      renderDeliveryDate(element);
    }
  });

  element.deliveryDateObserver.observe(element, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden', 'data-min-business-days', 'data-max-business-days']
  });
};

if (!customElements.get('product-delivery-date')) {
  class ProductDeliveryDate extends HTMLElement {
    connectedCallback() {
      renderDeliveryDate(this);
      watchDeliveryDate(this);
    }

    disconnectedCallback() {
      this.deliveryDateObserver?.disconnect();
      this.deliveryDateObserver = null;
    }
  }

  customElements.define('product-delivery-date', ProductDeliveryDate);
}

const renderAllDeliveryDates = (root = document) => {
  root
    .querySelectorAll('product-delivery-date')
    .forEach((element) => {
      element.dataset.rendered = 'false';
      renderDeliveryDate(element);
      watchDeliveryDate(element);
    });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => renderAllDeliveryDates(),
    { once: true }
  );
} else {
  renderAllDeliveryDates();
}

document.addEventListener('shopify:section:load', (event) => {
  renderAllDeliveryDates(event.target);
});
